// Pendiente de revisar
import { DatasetDtoBase } from "../Base/dataset-dto";
import { TermDtoV2 } from "../Governance/term-dto-v2";
import { AccessRightDto } from "../access-rights";
import { CatalogueRecordDto } from "../catalogue-record-dto";
import { CategoryDtoV2 } from "@/shared/dtos/Governance/category-dto-v2.ts";

export class DatasetDtoV2 extends DatasetDtoBase {
	public datasetId: string;
	public title: string;
	public name: string;
	public description?: string;
	public comment?: string;
	public icon: string;
	public accessRightsId!: number;
	public visibility!: string;
	public categories: CategoryDtoV2[] = [];
	public terms: TermDtoV2[] = [];
	public recordTitle: string;
	public recordDescription: string;
	public catalogRecord?: CatalogueRecordDto;
	public accessRights: AccessRightDto;

	constructor(src?: any) {
		super(src);
		Object.assign(this, src);
		this.datasetId = src?.id || src?.dataset?.id;
	}
}
